export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Валюта"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Есеп жасау"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Валюта нәтижесі"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жүктеу"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Парақ"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рұқсат етілген файл форматы - xlsx"])}
}